import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { forwardRef } from 'react';
// import { SummaryTable } from '../../molecules/SummaryTable/SummaryTable';
import { useTheme } from '../../theme';
export const DataTableBody = forwardRef(function DataTableHeader({ children }, ref) {
    const theme = useTheme();
    // TODO: enable again when solution for Icon/Text Dataset is ready
    // if (children.type !== SummaryTable) {
    //   console.error('DataTableBody expects a SummaryTable');
    //   return null;
    // }
    return (_jsx(Box, { padding: theme.spacing(105, 0), ref: ref, children: children }));
});
